import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getContent = () => axios.get(`${API}/content`).then((r) => r.data);

export const submitRegistration = (formData) =>
  axios.post(`${API}/registrations`, formData).then((r) => r.data);

export const submitContact = (payload) =>
  axios.post(`${API}/contact`, payload).then((r) => r.data);

const authHeader = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("hath_admin_token")}` } });

export const adminLogin = (email, password) =>
  axios.post(`${API}/admin/login`, { email, password }).then((r) => r.data);

export const adminGetRegistrations = () =>
  axios.get(`${API}/admin/registrations`, authHeader()).then((r) => r.data);

export const adminGetContacts = () =>
  axios.get(`${API}/admin/contacts`, authHeader()).then((r) => r.data);

export const adminSaveContent = (content) =>
  axios.put(`${API}/admin/content`, content, authHeader()).then((r) => r.data);
